import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import AdminNavbar from './AdminNavbar';
import './admin-animations.css';
import '../Navbar.css';

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [showToTop, setShowToTop] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const email = localStorage.getItem('userEmail');
    
    if (!isLoggedIn || !email) {
      navigate('/login');
      return;
    }

    // Détecter la taille d'écran pour la sidebar
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    handleResize(); // Appel initial
    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, [navigate]);

  // Gestion du bouton "to top"
  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || window.pageYOffset;
      // Contrôler la visibilité du bouton toTop - apparaît après 50px de scroll sur mobile, 200px sur desktop
      const isMobileWidth = window.innerWidth <= 1360;
      setShowToTop(y > (isMobileWidth ? 50 : 200));
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
    }}>
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      
      {/* Main Content Area */}
      <div style={{
        flex: 1,
        marginLeft: !isMobile ? (sidebarOpen ? '280px' : '70px') : '0',
        transition: 'margin-left 0.3s ease',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Navbar */}
        <AdminNavbar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        
        {/* Page Content */}
        <main style={{
          flex: 1,
          padding: isMobile ? '12px' : '20px',
          marginTop: '64px', // Account for navbar height
          overflowY: 'auto'
        }}>
          {children}
        </main>
      </div>
      
      {/* Bouton To Top - Desktop */}
      <div 
        id="toTop" 
        role="button" 
        className={showToTop ? 'show' : ''} 
        title="Back to top" 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      ></div>
      
      {/* Bouton To Top - Mobile */}
      <div 
        id="mobileToTop" 
        className={`mobile-top-button ${showToTop ? 'show' : ''}`}
        title="Back to top" 
        role="button"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
      </div>
    </div>
  );
};

export default AdminLayout;